import { REGISTRATION_LEAD_STATUS_LABELS } from '../constants/registrationLeadStatuses.js';
import { REGISTRATION_STATUS_OPTIONS } from '../constants/registrationStatuses.js';

export const UPCOMING_REGISTRATION_TYPE = 'upcoming_registration';

export const CATEGORY_LABEL = {
  [UPCOMING_REGISTRATION_TYPE]: 'Upcoming registration',
  callback_request: 'Callback',
  pdf_request: 'PDF',
  incoming_call: 'Incoming call',
  office_visit: 'Office visit'
};

export const CRM_STATUS_OPTIONS = [
  { value: 'converted', label: 'Converted' },
  { value: 'pending', label: 'Pending' },
  { value: 'ringing', label: 'Ringing' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'closed', label: 'Closed' }
];

export const MANUAL_LEAD_TYPE_OPTIONS = [
  { value: 'callback_request', label: 'Callback request' },
  { value: 'pdf_request', label: 'PDF request' },
  { value: 'incoming_call', label: 'Incoming call' },
  { value: 'office_visit', label: 'Office visit' }
];

/** Nearest upcoming batch for a trek (manual lead create). */
export function getUpcomingBatchForTrek(batches, trekId) {
  if (!trekId || !Array.isArray(batches)) return null;
  let best = null;
  for (const b of batches) {
    const id = String(b.trekId ?? b.trek?.id ?? '');
    if (id !== String(trekId)) continue;
    if (!best || String(b.startDate || '') < String(best.startDate || '')) {
      best = b;
    }
  }
  return best;
}

const CRM_STATUS_LABELS = Object.fromEntries(CRM_STATUS_OPTIONS.map((o) => [o.value, o.label]));

export function formatLeadDate(createdAt) {
  if (!createdAt) return '—';
  const d = new Date(createdAt);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatBatchDates(startDate, endDate) {
  const fmt = (raw) => {
    if (!raw) return '';
    const x = new Date(raw);
    if (Number.isNaN(x.getTime())) return '';
    return x.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };
  const a = fmt(startDate);
  const b = fmt(endDate);
  if (a && b && a !== b) return `${a} – ${b}`;
  return a || b || '—';
}

export function registrationStatusLabel(value) {
  if (value == null || String(value).trim() === '') return '—';
  const v = String(value).trim().toLowerCase();
  const hit = REGISTRATION_STATUS_OPTIONS.find((o) => o.value === v);
  if (hit) return hit.label;
  return String(value).replace(/_/g, ' ');
}

export function leadStatusLabel(lead) {
  if (!lead) return '—';
  const regStatus = String(lead.registrationStatus || '').trim().toLowerCase();
  if (regStatus === 'confirmed' || regStatus === 'advanced_paid') {
    return 'Converted';
  }
  const key = String(lead.leadStatus || '').trim();
  if (key === 'converted') return 'Converted';
  if (key) return REGISTRATION_LEAD_STATUS_LABELS[key] || key;
  return 'Not set';
}

export function resolveLeadDisplay(lead, booking) {
  const isUpcomingReg = lead?.leadType === UPCOMING_REGISTRATION_TYPE;
  const packageName = isUpcomingReg
    ? booking?.joinFromPackage?.name || lead?.packageName || '—'
    : '—';
  const eventDate =
    lead?.eventDateLabel ||
    formatBatchDates(
      booking?.batch?.startDate || lead?.batchStartDate,
      booking?.batch?.endDate || lead?.batchEndDate
    );
  const trekEvent = booking?.batch?.trek?.name || lead?.eventLabel || '—';
  const registrationStatus = isUpcomingReg
    ? registrationStatusLabel(booking?.registration?.status ?? lead?.registrationStatus)
    : '—';

  return { packageName, eventDate, trekEvent, registrationStatus, isUpcomingReg };
}

export function splitFullName(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return { firstName: '', lastName: '' };
  const space = trimmed.indexOf(' ');
  if (space === -1) return { firstName: trimmed, lastName: '' };
  return { firstName: trimmed.slice(0, space), lastName: trimmed.slice(space + 1).trim() };
}
